import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { nttPageMeta, nttSchema } from 'components/common/schema'
import Template from 'components/cases/ntt'

const Ntt: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...nttPageMeta} />
      <JsonLd data={nttSchema} />
      <Template />
    </>
  )
}

export default Ntt
